import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'react-simple-toasts/dist/theme/dark.css'; 


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
